module.exports = __webpack_public_path__ + "img/science.38b71388.jpg";